import { useDataIsSubmitting, useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'steps',
    viewPath: props.viewPath,
  })

  let index = useDataValue({
    context: 'selected',
    path: 'index',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'changeStatus',
      value: 'completed',
      index,
    })
  }
}

export function useIsDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'steps',
    viewPath: props.viewPath,
  })

  let value = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return !validate(value) || isSubmitting
}

function validate(value) {
  if (value.step_type === 'automation') {
    return isAutomationValid(value)
  }

  if (
    value.step_type === 'preferences' &&
    value.required &&
    value.value === null
  ) {
    return false
  }

  return true
}

function maybeTaskInAutomationValidation(value) {
  // is a task expected?
  if (!value?.actions?.some(action => action.type === 'TASK_INSERT'))
    return true

  // mamdatory task validation fields
  return (
    value.event.actionData.boardId &&
    value.event.actionData.stageId &&
    value.event.actionData.title &&
    isValidAction(value.event.actionData?.actions)
  )
}

function isValidAction(actions = []) {
  return actions?.length > 0 ? actions[0].document_template_id !== null : true
}

function isAutomationValid(value) {
  switch (value.event.type) {
    case 'APPOINTMENT_BOOKING_STATE_UPDATE': {
      return (
        value.event.data.appointmentTypeIds.length > 0 &&
        value.event.data.valueTo.length > 0 &&
        maybeTaskInAutomationValidation(value)
      )
    }
    case 'TREATMENT_STATUS_UPDATE': {
      return (
        value.event.data.valueTo.length > 0 &&
        maybeTaskInAutomationValidation(value)
      )
    }
    case 'RESOURCE_INSERT': {
      // currently resource only inserts a task
      return maybeTaskInAutomationValidation(value)
    }
    default: {
      return true
    }
  }
}
